// VITE_API_BASE: URL base para el cliente Axios.
// - En desarrollo: no definir → usa '/api' → el proxy de Vite reescribe a localhost:4001
// - En producción: definir VITE_API_BASE=https://api.tryger.com
//
// VITE_APP_API sigue disponible en los componentes (App.vue, ModalUpdateTemplate, etc.)
// para construir URLs directas de imágenes/uploads.
const baseApiUrl = import.meta.env.VITE_API_BASE || '/api';

export default baseApiUrl;
